import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'

import {
  BirthdayAvailability,
  BirthdayAvailabilityResponse,
} from '@facades/birthday'
import { getEndpoint } from '@utils/getEndpoint'

const fetchBirthdayAvailability = async (
  date: string,
  age: number
): Promise<BirthdayAvailabilityResponse> => {
  const response = await axios.post<BirthdayAvailabilityResponse>(
    `${getEndpoint()}/birthday/availability`,
    { date, age }
  )
  return response.data
}

export const useBirthdayAvailability = (
  date: string,
  age: number,
  enabled = true
) => {
  const query = useQuery<BirthdayAvailabilityResponse, AxiosError>(
    ['birthday', 'availability', date, age],
    () => fetchBirthdayAvailability(date, age),
    { enabled: enabled && Boolean(date) }
  )

  return {
    data: (query.data?.availability ?? {}) as Record<
      string,
      BirthdayAvailability | undefined
    >,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: async () => {
      const result = await query.refetch()
      if (result.isError) {
        throw result.error instanceof Error
          ? result.error
          : new Error('Unable to refresh birthday availability')
      }
      return result
    },
  }
}
